import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {PipesModule} from '../../pipes/pipes.module'

@Component({
  selector: 'bgo-top-partner-banner',
  templateUrl: './pro-top-partner-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PipesModule],
})
export class ProTopPartnerBannerComponent {
  bannerText = input.required<string>()
}
